import {
  PulsoDigitalView, PulsoDigitalMapView, TicketDetailTicView, PulsoDigitalProacSandetel,
} from '@/views';

const camelize = (param) => (param ? param.replace(/-(\w)/ig, (repl) => repl.substring(repl.lastIndexOf('-') + 1).toUpperCase()) : undefined);

const parseQuery = function parseQuery(query, excludedKeys = []) {
  return Object.fromEntries(Object.entries(query)
    .filter((queryParam) => !excludedKeys.includes(queryParam))
    // replace '-' to camelcase
    .map((entry) => ([
      camelize(entry[0]),
      entry[1],
    ])));
};

const routes = {
  privatePaths: [
    {
      path: '/pulsodigital',
      component: PulsoDigitalView,
      children: [
        {
          path: '',
          component: PulsoDigitalView,
          name: 'PulsoDigitalView',
        },
      ],
    },
    {
      path: '/pulsodigital/map/:id?',
      component: PulsoDigitalMapView,
      name: 'PulsoDigitalMap',
      props: ({ params }) => ({
        id: params.id,
        idNodo: params.idNodo,
      }),
    },
    {
      path: '/pulsodigital/requests/:idTicket',
      component: TicketDetailTicView,
      name: 'TicketDetailTicView',
      props: ({ query, params }) => {
        const queryParams = parseQuery(query, ['action']);
        return {
          ticketType: 'requests',
          idTicket: params.idTicket,
          action: query.action ? camelize(query.action) : '',
          params: queryParams,
          pulsoDataExt: params.pulsoDataExt,
          isTIC: true,
        };
      },
    },
    {
      path: '/pulsodigital/incidenciasproactivas',
      component: PulsoDigitalProacSandetel,
      name: 'PulsoDigitalProacSandetel',
      props: () => {},
    },
    {
      path: '/pulsodigital/incidenciasproactivas/requests/:idTicket',
      component: TicketDetailTicView,
      name: 'TicketDetailTicViewProact',
      props: ({ query, params }) => {
        const queryParams = parseQuery(query, ['action']);
        return {
          ticketType: 'requests',
          idTicket: params.idTicket,
          action: query.action ? camelize(query.action) : '',
          params: queryParams,
          pulsoDataExt: params.pulsoDataExt,
          isTIC: true,
          listProac: params.list,
          getListProac: params.getListProac,
        };
      },
    },
  ],
  publicPaths: [],
};

export default routes;
